import { useQuery } from "@tanstack/react-query";
import { customerService } from "../services/customerService";

export const useCustomerCpf = (cpf?: string) => {
  const { data, isFetching, isLoading, isSuccess } = useQuery({
    queryKey: ["customerCpf", cpf],
    queryFn: () => customerService.customerCpf(cpf!),
    enabled: !!cpf && cpf.length === 11,
  });

  return {
    data,
    isFetching,
    isLoading,
    isSuccess,
  };
};
